export default "__VITE_ASSET__D$sPX1hV__"